import { useQuery } from "@tanstack/react-query";
import { System } from "@graylog/server-api";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
export const fetchSystemInfo = () => System.system();
export const fetchSystemJvm = () => fetch("GET", qualifyUrl(ApiRoutes.SystemApiController.jvm().url));
export const fetchSystemLocales = () => fetch("GET", qualifyUrl(ApiRoutes.SystemApiController.locales().url));
const useSystemInfo = () => useQuery({ queryKey: ["system", "info"], queryFn: fetchSystemInfo });
export const useSystemLocales = () => useQuery({
  queryKey: ["system", "locales"],
  queryFn: fetchSystemLocales,
  select: (data) => data.locales
});
export { useSystemInfo };
export default useSystemInfo;
